import { render, staticRenderFns } from "./OrganizationTypeAheadSelector.vue?vue&type=template&id=6b0b8f1a"
import script from "./OrganizationTypeAheadSelector.vue?vue&type=script&lang=js"
export * from "./OrganizationTypeAheadSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0b8f1a')) {
      api.createRecord('6b0b8f1a', component.options)
    } else {
      api.reload('6b0b8f1a', component.options)
    }
    module.hot.accept("./OrganizationTypeAheadSelector.vue?vue&type=template&id=6b0b8f1a", function () {
      api.rerender('6b0b8f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganizationTypeAheadSelector.vue"
export default component.exports